var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"doc-book"}},[_c('p',[_vm._v("Bald werden Sie hier Ihr Kollektenbuch einsehen können!")])])
}]

export { render, staticRenderFns }